import Item from "./Item";
import Title from "../Common/Title";
import Subtitle from "../Common/Subtitle";
import PropTypes from "prop-types";
import noList from "../../assets/images/no_list.webp";

function Pricing({offers, title, subtitle, color, special, isLoading = false}) {
  return (
    <div className="px-5">
      <div className="mx-auto max-w-7xl px-6 lg:px-8 select-none">
        <div className="mx-auto max-w-4xl text-center space-y-6">
          <Title color={color} title={title} />
          <Subtitle color={color} title={subtitle} />
        </div>
      
        <div className="isolate mx-auto mt-10 lg:px-24 grid max-w-md grid-cols-1 gap-8 lg:mx-0 lg:max-w-none lg:grid-cols-3">
          {isLoading && Array.from({ length: 3 }).map((_, index) => (
            <Item key={`tier-loading-${index}`} tier={{}} isLoading={isLoading}/>
          ))}
          {!isLoading && !offers?.length && (
            <div className="col-span-full flex justify-center">
              <img src={noList} alt="No results" className="max-w-xs w-full" />
            </div>
          )}
          {!isLoading && offers?.map((tier, index) => (
            <Item key={`tier-${index}`} tier={tier} special={special}/>
          ))}
        </div>
      </div>
    </div>
  );
}

Pricing.propTypes = {
  offers: PropTypes.array,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  color: PropTypes.bool,
  special: PropTypes.bool,
  isLoading: PropTypes.bool,
};

export default Pricing;